<script setup lang="ts">
const currentYear = new Date().getFullYear();
</script>

<template>
    <div class="space-y-4 text-sm">
        <div>&copy; Arizona Game and Fish Department {{ currentYear }}</div>
        <div>
            <a href="https://www.azgfd.com/azgfd-privacy-policy" class="text-(--az-green-600) underline" target="_blank">Privacy Policy</a>
            |
            <a href="https://www.azgfd.com/azgfd-terms-of-use" class="text-(--az-green-600) underline" target="_blank">Terms of Use</a>
        </div>
    </div>
</template>
